var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getGlobalState } from '../../Utils/GlobalState';
import axios from 'axios';
import Checkbox from '../../Components/ComponentCheckbox';
import T from '../../Utils/Locale';
const PermissionsCheckbox = ({ checked, permission, partnerId = null }) => {
    const [hasAccepted, setAccepted] = useState(checked);
    const [loading, setLoading] = useState(false);
    const toggleAccepted = () => { setAccepted(!hasAccepted); };
    function toggle() {
        return __awaiter(this, void 0, void 0, function* () {
            setLoading(true);
            try {
                const applicationUrl = getGlobalState('application_url');
                const data = {
                    permission: permission,
                    partnerId: partnerId
                };
                yield axios.post(`${applicationUrl}/api/user/permissions/toggle`, data, { withCredentials: true });
                yield toggleAccepted();
                setLoading(false);
            }
            catch (exception) {
                setLoading(false);
                return false;
            }
        });
    }
    return (_jsxs(_Fragment, { children: [loading && (_jsx("i", { className: 'fas fa-spinner-third fa-spin', "aria-hidden": 'true' })), !loading && hasAccepted && (_jsx(Checkbox, { classes: 'font-light leading-relaxed text-gray-69 !important cursor-pointer', onChange: toggle, startChecked: hasAccepted, id: `${permission}-${partnerId}`, label: T('misc.accepted') })), !loading && !hasAccepted && (_jsx(Checkbox, { classes: 'font-light leading-relaxed text-gray-69 !important cursor-pointer', onChange: toggle, startChecked: hasAccepted, id: `${permission}-${partnerId}`, label: T('misc.not_accepted') }))] }));
};
PermissionsCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    permission: PropTypes.string.isRequired,
    partnerId: PropTypes.string
};
export default PermissionsCheckbox;
